import type { FC } from 'react';

import { CatalogBrowser } from '@entities/Offer';
import type { Offer } from '@psp-aggregator/sdk';

export interface OfferCatalogProps {
  onSelectionChange: (offers: Offer[]) => void;
  selectedIds: readonly string[];
}

export const OfferCatalog: FC<OfferCatalogProps> = (props) => (
  <CatalogBrowser
    onSelectionChange={props.onSelectionChange}
    selectedIds={props.selectedIds}
  />
);

OfferCatalog.displayName = 'OfferCatalog';
